import { NgModule } from '@angular/core';
import { LibMortgageIconComponent } from './lib-mortgage-icon.component';

@NgModule({
  declarations: [LibMortgageIconComponent],
  imports: [],
  exports: [LibMortgageIconComponent],
})
export class LibMortgageIconModule {}
